<template>
  <InvestorGateRoute
    auth-scope="onepager"
    storage-key="investor_onepager_auth"
    analytics-source="onepager_gate"
    :deck-loader="loadDeck"
  />
</template>

<script>
import InvestorGateRoute from '@/components/InvestorGateRoute.vue';
import ensureInvestorDeckLoaded from '@/lib/investorChunkLoader';

export default {
  name: 'InvestorTeaser',
  components: { InvestorGateRoute },
  methods: {
    async loadDeck() {
      // Pre-populate webpack's chunk registry from the auth-gated endpoint
      // so the dynamic import below resolves from cache without ever
      // requesting the (intentionally absent) public chunk URL.
      await ensureInvestorDeckLoaded('onepager');
      return import(
        /* webpackChunkName: "investor-teaser-deck" */ './InvestorTeaserDeck.vue'
      );
    },
  },
};
</script>
